import { getUpdateSchedulesFunction } from 'components/Templates/product/default/ProductEditDefaultTemplate'
import { Dispatch, SetStateAction, useCallback } from 'react'
import { StockUnionType } from 'types/stock'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const useSelectDefaultMaximumOrder = (
  setDailySchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>
): ((value: string, type: StockUnionType) => void) => {
  return useCallback(
    (value: string, type: StockUnionType) => {
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      update((prevState) => {
        const nextState = prevState.map((schedule) => {
          schedule.maximum_order = Number(value)
          return schedule
        })
        return [...nextState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useSelectDefaultMaximumOrder
